import { createWebHistory, createRouter } from "vue-router";

const routes = [
    {
        path: "/",
        name: "Home",
        component: () => import(/* webpackPrefetch: true */ '@/views/Home')
    },
    {
        path: '/destination/:id/:place',
        name: "HotDestination",
        component: () => import(/* webpackPrefetch: true */ '@/views/HotDestination'),
        props: true,
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: '熱門目的地'
            }]
        }
    },
    {
        path: '/search/:scope/:keyword',
        name: "Search",
        component: () => import(/* webpackPrefetch: true */ '@/views/Product'),
        props: true,
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: 'search'
            }]
        }
    },
    {
        path: "/product/car-rental-service",
        name: "CarRentalService",
        component: () => import(/* webpackPrefetch: true */ '@/views/CarRentalService'),
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: '包車及接送'
            }]
        }
    },
    {
        path: "/product/car-rental/:mode?",
        name: "CarRental",
        component: () => import(/* webpackPrefetch: true */ '@/views/CarRental'),
        props: route => ({
            mode: route.params.mode
        }),
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: '自駕遊'
            }]
        }
    },
    {
        path: "/product/coach-hire-custom",
        name: "CoachHireCustom",
        component: () => import(/* webpackPrefetch: true */ '@/views/CoachHireCustom'),
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: '包車及接送',
                link: '/product/car-rental-service'
            },
            {
                name: '包車服務 (自訂)'
            }]
        }
    },
    {
        path: "/product/coach-hire-suggest",
        name: "CoachHireSuggest",
        component: () => import(/* webpackPrefetch: true */ '@/views/CoachHireSuggest'),
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: '包車及接送',
                link: '/product/car-rental-service'
            },
            {
                name: '包車服務 (精選)'
            }]
        }
    },
    {
        path: '/product/:category/:area?',
        name: "Product",
        component: () => import(/* webpackPrefetch: true */ '@/views/Product'),
        props: true,
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: 'category'
            },
            {
                name: 'location'
            }]
        }
    },
    {
        path: "/product/detail/:category/:code",
        name: "Product Detail",
        component: () => import(/* webpackPrefetch: true */ '@/views/ProductDetail'),
        props: route => ({
            category: route.params.category,
            code: route.params.code
        }),
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: 'category',
                link: ''
            },
            {
                name: 'code'
            }]
        }
    },
    {
        path: "/cart",
        name: "Cart",
        component: () => import(/* webpackPrefetch: true */ '@/views/ShoppingCart'),
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: '購物車'
            }]
        }
    },
    {
        path: "/booking",
        name: "Booking",
        component: () => import(/* webpackPrefetch: true */ '@/views/Booking'),
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: '購物車'
            }]
        }
    },
    {
        path: "/confirm",
        name: "Confirm",
        component: () => import(/* webpackPrefetch: true */ '@/views/Confirm'),
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: '購物車'
            }]
        }
    },
    {
        path: "/checkout",
        name: "Checkout",
        component: () => import(/* webpackPrefetch: true */ '@/views/Checkout'),
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: '購物車'
            }]
        }
    },
    {
        path: "/callback",
        name: "Callback",
        component: () => import(/* webpackPrefetch: true */ '@/views/Callback'),
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: '購物車'
            }]
        }
    },
    {
        path: "/history",
        name: "History",
        component: () => import(/* webpackPrefetch: true */ '@/views/History'),
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: '已瀏覽產品'
            }]
        }
    },
    {
        path: "/faq",
        name: "FAQ",
        component: () => import(/* webpackPrefetch: true */ '@/views/FAQ'),
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: '常見問題'
            }]
        }
    },
    {
        path: "/partnership",
        name: "Partnership",
        component: () => import(/* webpackPrefetch: true */ '@/views/Partnership'),
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: '合作機會'
            }]
        }
    },
    {
        path: "/recommendation/:label?",
        name: "Recommendations",
        component: () => import(/* webpackPrefetch: true */ '@/views/Recommendations'),
        props: route => ({
            label: route.params.label
        }),
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: '旅遊達人精選推介'
            }]
        }
    },
    {
        path: "/recommendation/detail/:pk",
        name: "RecommendationDetail",
        component: () => import(/* webpackPrefetch: true */ '@/views/RecommendationDetail'),
        props: route => ({
            pk: route.params.pk
        }),
        meta: {
            breadcrumb: [{
                name: '首頁',
                link: '/'
            },
            {
                name: '旅遊達人精選推介',
                link: '/recommendation'
            },
            {
                name: 'hello'
            }]
        }
    },
    {
        path: "/login",
        name: "Login",
        component: () => import(/* webpackPrefetch: true */ '@/views/Login')
    },
    {
        path: '/logging',
        name: 'Logging',
        component: () => import(/* webpackPrefetch: true */ '@/views/Logging')
    },
    {
        path: '/404',
        name: '404',
        component: () => import(/* webpackPrefetch: true */ '@/views/NotFound')
    },
    {
        path: '/:pathMatch(.*)',
        redirect: '/404'
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        window.scrollTo(0, 0);
    }
});

router.beforeEach((to, from, next) => {
    //console.log(`Navigating to: ${to.name}`);
    next();
});

export default router;